export var brandColors = {
    deep: {
        '900': '#030823',
        '800': '#091139',
        '700': '#121B4B',
        '600': '#092560',
        '500': '#303B72',
        '400': '#404C8C',
        '300': '#4E5CA8',
        '200': '#4E5CA8',
        '100': '#A3B0F6',
    },
    giv: {
        '1000': '#02001B',
        '900': '#090446',
        '800': '#1B1657',
        '700': '#211985',
        '600': '#3811BF',
        '500': '#5326EC',
        '400': '#754CFF',
        '300': '#8668FC',
        '200': '#B9A7FF',
        '100': '#E7E1FF',
        '50': '#F6F3FF',
        '000': '#FCFCFF',
    },
    cyan: {
        '800': '#007C8F',
        '700': '#0097AE',
        '600': '#00AFCB',
        '500': '#2FC8E0',
        '400': '#3EDBF3',
        '300': '#87E7F5',
        '200': '#BFF4FC',
    },
    mustard: {
        '800': '#C6920C',
        '700': '#DAA213',
        '600': '#E8B83D',
        '500': '#FED670',
        '400': '#FFE49D',
        '300': '#FFEEC1',
        '200': '#FFF7E0',
    },
    pinky: {
        '800': '#AA004F',
        '700': '#C7035E',
        '600': '#D81A72',
        '500': '#E1458D',
        '400': '#FD67AC',
        '300': '#FF96C6',
        '200': '#FFC9E2',
    },
    ocean: {
        '900': '#210095',
        '800': '#310BB5',
        '700': '#0038AF',
        '600': '#0040C9',
        '500': '#165FFA',
        '400': '#3E7CFF',
        '300': '#6496FF',
        '200': '#A0BFFF',
    },
};
export var semanticColors = {
    jade: {
        '700': '#1B8C82',
        '600': '#2EA096',
        '500': '#37B4A9',
        '400': '#5CD3C9',
        '300': '#7CE8DF',
        '200': '#A9F8F1',
        '100': '#D2FFFB',
    },
    blueSky: {
        '700': '#2C66CD',
        '600': '#0083E0',
        '500': '#0A91FE',
        '400': '#24A4FF',
        '300': '#52B7FF',
        '200': '#8DD0FF',
        '100': '#CAE9FF',
    },
    punch: {
        '700': '#C71D06',
        '600': '#D93119',
        '500': '#E6492D',
        '400': '#F96E5B',
        '300': '#FF8A7A',
        '200': '#FFB3A9',
        '100': '#FFD6D0',
    },
    golden: {
        '700': '#EA960D',
        '600': '#F6AB2F',
        '500': '#FFBF56',
        '400': '#FFCD7A',
        '300': '#FFEAB5',
        '200': '#FFF3D2',
        '100': '#FFFBEF',
    },
};
export var neutralColors = {
    gray: {
        '900': '#1D1E1F',
        '800': '#4F576A',
        '700': '#82899A',
        '600': '#A5ADBF',
        '500': '#BBC3D4',
        '400': '#D7DDEA',
        '300': '#EBECF2',
        '200': '#F7F7F9',
        '100': '#FFFFFF',
    },
};
